// @flow

import moment from 'moment';
import utils from 'sling-calendar-sdk/utils';

import { DATE_FORMAT, SHORT_DAY_NAME_FORMAT_US, SHORT_DAY_NAME_FORMAT_EU } from '../constants';

export const {
  formatTime,
  getRealDate,
  getDisplayDuration,
  dateFromHours,
  subtractDates,
  formatShortTime
} = utils;

export function formatDate(date: Date = new Date()): string {
  return moment(date).format(DATE_FORMAT);
}

export function toDateShort(date: Date = new Date(), usTimeFormat: boolean): string {
  const format = usTimeFormat ? SHORT_DAY_NAME_FORMAT_US : SHORT_DAY_NAME_FORMAT_EU;

  return moment(date).format(format);
}

export function isServerError(error: Object | string | Array<string>): boolean {
  if (typeof error === 'string' || Array.isArray(error)) {
    return false;
  }
  return typeof error.status !== 'undefined' && typeof error.response !== 'undefined';
}

export function isIE(): boolean {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ');

  if (msie >= 0) {
    return true;
  }

  const trident = ua.indexOf('Trident/');
  return trident >= 0;
}

export function getPathFromUrl(url: string): string {
  return url.split(/[?#]/)[0];
}

export function isHalloween() {
  const today = new Date();
  const date = today.getDate();
  const month = today.getMonth();

  return month === 9 && date > 27 && date <= 31;
}
